import {FeatureFlag, FeatureFlagKey} from '../featureFlags.types';
import map from 'lodash/fp/map';
import pipe from 'lodash/fp/pipe';

export default function toSetOfFlagKeys(flags: FeatureFlag[]): Set<FeatureFlagKey> {
  return pipe(
    map(({key}: FeatureFlag) => key),
    (flagKeys) => new Set(flagKeys),
  )(flags);
}
